<template>
    <div class="form-item-container">
        <div class="form-item-header">
            <v-btn class="gorate-bg cursor-default" :icon="getFormItemIconIndex" height="30" variant="text" width="30"></v-btn>
            <div class="question">
            </div>
        </div>
        <div class="form-item-body">
          <div class="submissions-container text-h5">{{ formItem.text_label_lang1 }}*</div>
          <div class="view-responses-container">*{{ $t('i18n.textLabelStatsLegend') }}</div>
        </div>
    </div>
</template>

<script lang="ts">
import { FormItem } from '@/utils/DataTypes'
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'TextLabelStats',
  props: {
    stats: {
      type: Object,
      required: true,
      default: null
    },
    formItem: {
      type: Object as PropType<FormItem>,
      required: true,
      default: null
    },
    formItemIndex: {
      type: Number,
      required: true,
      default: -1
    },
    formName: {
      type: String,
      required: false,
      default: 'N/A'
    }
  },
  computed: {
    getFormItemIconIndex () : string {
      return `mdi-numeric-${this.formItemIndex}`
    }
  }
})
</script>

<style lang="scss" scoped>
@import "../../../styles/colors.scss";

.form-item-container {
  padding: 1.0em 1.5em;
  border-radius: 0px 0px 15px 15px;

  display: grid;
  grid-template-rows: auto 1fr;

  .form-item-header {
      display: grid;
      grid-template-columns: auto auto;
      justify-content: start;

      .question {
          padding: 0 0.8em;
      }
  }

  .form-item-body {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(2, auto);
    align-items: center;

    .submissions-container {
      display: grid;
      align-self: end;
      justify-content: center;
    }

    .view-responses-container {
      align-self: self-end;
      justify-self: end;
      padding-top: 1.2em;
    }
  }
}
</style>
